<p>
  След сключване на сделка, комуникацията с купувача е от съществено значение за успешното изпълнение на доставката,
  плащането и общото удовлетворение от транзакцията.
</p>
<h6 class="mt-3">1. След покупка или спечелен търг</h6>
<p class="mb-1">
  Веднага след като купувачът потвърди покупка или спечели търг, платформата автоматично създава <strong>личен
  чат</strong> между вас и него.
</p>
<ul>
  <li>На страницата на обявата ще се появи бутон <strong>„Съобщение до купувача“</strong>.</li>
  <li>След изпращане на първото съобщение, чатът ще бъде достъпен и в секцията <strong>„Съобщения“</strong> от вашия
    профил.
  </li>
  <li>Използвайте чата, за да уточните всички важни подробности – метод на плащане, куриер, адрес, срок за доставка и
    др.
  </li>
</ul>
<h6 class="mt-3">2. При прието ценово предложение</h6>
<p>
  Ако купувач е изпратил <strong>ценово предложение</strong>, което вие сте приели, платформата отново ще създаде
  <strong>чат</strong> между двете страни.
</p>
<p>
  Чрез него може да уточните финалните условия по сделката и да поддържате комуникация до завършване на процеса.
</p>
<h6 class="mt-3">3. Къде се намират всички разговори?</h6>
<p>
  Всички създадени разговори с купувачи се намират в <strong>„Профил“ → „Съобщения“</strong>. Оттам може да
  преглеждате хронологията, да отговаряте на нови съобщения и да следите хода на всяка сделка.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Отговаряйте навременно и поддържайте коректна комуникация. Това подобрява вашата репутация в
  платформата и увеличава шансовете за положителен отзив от купувача.
</div>
